import axios from "axios";

const baseURL = process.env.REACT_APP_BASE_API_URL;

const instance = axios.create({
  baseURL: baseURL
});

export default instance;

/**
 * Retry an axios request 3 times with an exponential backoff.
 * @param req A function that resolves to an axios response, or rejects with an axios error.
 */
export async function withRetry(req) {
  const initialDelayInMs = 100;
  const maxAttempts = 4;

  for(let attempt = 0; /* exit conditions in loop body */; attempt++) {
    try {
      return await req();
    } catch (e) {
      // If we've exhausted our attempts...
      if (attempt >= maxAttempts) {
        throw e;
      }

      // Or the error is a client error...
      const status = e?.response?.status;
      if (status !== 429 && (status >= 400 && status < 500)) {
        throw e;
      }

      // Otherwise, delay, and retry (100, 200, 400, 800)
      const delay = (2 ** attempt) * initialDelayInMs
      await new Promise(r => setTimeout(r, delay));
    }
  }
}
